module.exports = __webpack_public_path__ + "static/media/image-15.1709fffa.PNG";